import { HStack, VStack } from '@sgme/ui';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

type ExecutionStatusProps = {
  isEditing?: boolean;
};

export const ExecutionPendingOrderStatus = (props: ExecutionStatusProps) => {
  const { isEditing = false } = props;

  return (
    <VStack
      flex="expand"
      horizontalAlignment="center"
      verticalAlignment="center"
      className="bg-lvl1 w-100 h-100 pb-16px"
    >
      <HStack
        horizontalAlignment="center"
        verticalAlignment="center"
        className={clsx('bg-opacity-10 rounded-circle mb-3 bg-warning')}
        style={{ width: 48, height: 48 }}
        data-e2e="execution-status-PENDING"
      >
        <i className={clsx('icon icon-md line-height-1 text-warning')}>hourglass_empty</i>
      </HStack>

      <h4 className="text-warning" data-e2e="execution-status">
        <FormattedMessage id={'tile.execution.status.order.PENDING'} values={{ isEditing }} />
      </h4>

      <div className="text-secondary" data-e2e="execution-description">
        <FormattedMessage id={'tile.execution.status.description.PENDING'} />
      </div>
    </VStack>
  );
};
